import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'noUnderscore',
    standalone: false
})
export class NoUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return value.replace(/_/g, ' ');
    }
  }
}
